import React, { useState } from "react";
import { FaBook, FaHeartbeat, FaSignOutAlt } from "react-icons/fa";
import {
  TbChartInfographic,
  TbLayoutGridAdd,
  TbChecklist,
} from "react-icons/tb";
import { BiLogIn } from "react-icons/bi";
import { IoIosArrowDropright, IoIosArrowDropleft } from "react-icons/io";
import Main from "../components/main";
import { Link } from "react-router-dom";
import {
  activeMenu,
  activeStanding,
  activeText,
  activeToggle,
} from "../utils/helper";
import Logo from "../assets/images/normal_logo.png";
import { useAuth } from "../services/authProvider";

function PatientLayout({ setLocale }) {
  const { logout } = useAuth();
  const [rtl, setRtl] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [image, setImage] = useState(true);
  const [toggled, setToggled] = useState(false);
  const patient = localStorage.getItem("patient");

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleRtlChange = (checked) => {
    setRtl(checked);
    setLocale(checked ? "ar" : "en");
  };
  const handleImageChange = (checked) => {
    setImage(checked);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className="app">
      <div
        className={`sidebar pb-2 shadow ${
          collapsed == true ? "collapsed" : "uncollapsed"
        }`}
      >
        <ul className="list-group">
          <div className="logo_img">
            <img
              src={Logo}
              className="img-fluid"
              width={119}
              height={60}
              alt=""
            />
          </div>
          <li>
            <Link
              to={"/patient"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/patient/home"
              )} noHover2`}
            >
              <i
                className={`fa fa-user icon-small ${
                  activeText("/patient/home") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/patient/home") && "text-white"
                  }`}
                >
                  Patient Homepage
                </small>
              )}
            </Link>
            <Link
              to={"/patient/enter_function"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/patient/enter_function"
              )} noHover2`}
            >
              <i
                className={`fa fa-edit icon-small ${
                  activeText("/patient/enter_function") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/patient/enter_function") && "text-white"
                  }`}
                >
                  Enter Functional Scores
                </small>
              )}
            </Link>
            <Link
              to={"/patient/view_function"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/patient/view_function"
              )} noHover2`}
            >
              <i
                className={`fa fa-bar-chart icon-small ${
                  activeText("/patient/view_function") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/patient/view_function") && "text-white"
                  }`}
                >
                  View Functional Scores
                </small>
              )}
            </Link>
            <Link
              to={"/patient/view_care"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/patient/view_care"
              )} noHover2`}
            >
              <i
                className={`fa fa-edit icon-small ${
                  activeText("/patient/view_care") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/patient/view_care") && "text-white"
                  }`}
                >
                  View Care Plan
                </small>
              )}
            </Link>
            <Link
              to={"/patient/outstanding"}
              className={`list-group-item my-0 border-0 h-40 pt-2 ${activeMenu(
                "/patient/outstanding"
              )} noHover2`}
            >
              <i
                className={`fa fa-book icon-small ${
                  activeText("/patient/outstanding") && "text-white"
                }`}
              />{" "}
              &nbsp;
              {!collapsed && (
                <small
                  className={`f-13 ${
                    activeText("/patient/outstanding") && "text-white"
                  }`}
                >
                  Outstanding Documents
                </small>
              )}
            </Link>
          </li>
        </ul>
        {/* <div className='m-4'> */}
        <a
          href="#"
          className="noHover2 mb-2 mx-2 px-4 py-2"
          onClick={() => logout()}
        >
          <FaSignOutAlt /> &nbsp; {!collapsed && <small>Log Out</small>}
        </a>
        {/* </div> */}
      </div>
      <div className="w-100">
        <Main handleCollapsedChange={handleCollapsedChange} page={"patient"} />
      </div>
    </div>
  );
}

export default PatientLayout;
